import React from "react";
import { LeftArrow, Logo, Successfull } from "../../assets/svg";
import ReactDOM from "react-dom";
import { FiExternalLink } from "react-icons/fi";

const Popup = ({ setAddedUser }) => {
  return ReactDOM.createPortal(
    <div className="z-20 fixed top-0 left-0 w-screen h-screen flex items-center justify-center">
      <div className="w-full rounded-3xl bg-[#2C2D36] mx-5 p-10 max-w-[375px] shadow-2xl shadow-[#292929]">
        <div className="flex items-center justify-center mb-5">
          <Successfull />
        </div>
        <p className="text-xs text-center">
          Your Registration is submitted Successfully.
        </p>
        <p className="text-xs text-center mt-4">
          Soon, we will share the access for the Strikie App with you
        </p>
        <p className="text-xs text-center mt-4">
          Meanwhile, you can explore us online
        </p>

        <div className="mt-4 text-center">
          <button
            onClick={() => setAddedUser(false)}
            className="text-xs bg-gradient-to-r from-pinkish to-purpleish max-w-fit px-5 py-2 rounded-2xl"
          >
            Get More Pass
          </button>
        </div>

        <div className="mt-4">
          <a
            href="https://www.strikie.com/"
            target="_blank"
            rel="noreferrer"
            className="text-xs text-[#FE0677] flex items-center justify-center"
          >
            www.strikie.com
            <FiExternalLink className="ml-1" />
          </a>
        </div>
      </div>
    </div>,
    document.body
  );
};

const EarlyAccessSuccessfullRegistration = ({ setAddedUser }) => {
  return (
    <>
      <header className="flex items-center justify-between p-5 max-w-screen-sm mx-auto">
        <Logo />
        <h3
          className="text-base font-bold flex items-center z-30 cursor-pointer"
          onClick={() => setAddedUser(false)}
        >
          Get More Pass <LeftArrow className="ml-3 rotate-180" />
        </h3>
      </header>
      <Popup setAddedUser={setAddedUser} />
    </>
  );
};

export default EarlyAccessSuccessfullRegistration;
